import { render, staticRenderFns } from "./UsersPerPeriodChart.vue?vue&type=template&id=3b8e4fa4"
import script from "./UsersPerPeriodChart.vue?vue&type=script&lang=js"
export * from "./UsersPerPeriodChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports